import {
  FETCH_MATCH_LIST,
  FETCH_RECOMMEND_MATCH_LIST,
  FETCH_MATCH_INTRODUCTION,
  FETCH_MATCH_DETAIL,
  TOGGLE_MATCH_FAVOUR,
  FETCH_WORLD_CUP_MATCH_LIST,
} from '../mutation-types'

const initialState = {
  match: [],
  recommendMatch: [],
  worldCupMatch: [],

  detail: {
    awayTeam: {},
    homeTeam: {},
    city: {},
  },
  introduction: {
    awayTeam: {},
    homeTeam: {},
    city: {},
  },
}

const mutations = {
  [FETCH_MATCH_LIST](state, data) {
    state.match = data.matches
  },

  [FETCH_RECOMMEND_MATCH_LIST](state, data) {
    state.recommendMatch = data.matches
  },

  [FETCH_MATCH_DETAIL](state, data) {
    state.detail = data
  },

  [FETCH_MATCH_INTRODUCTION](state, data) {
    state.introduction = data
  },

  [TOGGLE_MATCH_FAVOUR](state, data) {
    state.introduction.isFavorite = data
  },

  [FETCH_WORLD_CUP_MATCH_LIST](state, data) {
    state.worldCupMatch = data.matches
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/match.js